var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{fill:#d8001e;}.cls-5{fill:#1a237b;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 5,
    width: 24,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UNITED_KINGDOM",
    "data-name": "UNITED KINGDOM"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16.07 5.06 24 0.62 24 0 23.45 0 14.41 5.06 16.07 5.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "15.7 9.22 24 13.87 24 12.94 17.36 9.22 15.7 9.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0 1.07 7.1 5.06 8.76 5.06 0 0.14 0 1.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "8.39 9.22 0 13.92 0 14 1.51 14 10.05 9.22 8.39 9.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "22.36 0 13.96 0 13.96 4.71 22.36 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "10.24 0 1.88 0 10.24 4.71 10.24 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "24 5.06 24 1.85 18.3 5.06 24 5.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "24 12.4 24 9.22 18.3 9.22 24 12.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2.35 14 10.24 14 10.24 9.57 2.35 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "13.96 14 21.87 14 13.96 9.57 13.96 14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 9.22 0 12.54 5.9 9.22 0 9.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 5.06 5.9 5.06 0 1.74 0 5.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "10.99 0 10.99 5.89 0 5.89 0 8.39 10.99 8.39 10.99 14 13.21 14 13.21 8.39 24 8.39 24 5.89 13.21 5.89 13.21 0 10.99 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.311545d8ff19596c4b1087e96ad84ad1.svg";
export { ForwardRef as ReactComponent };